///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import { getCarrierManagementList } from "../api/api";

export const initialState = {
  isFetching: false,
  carriers: [],
};

const carrierManagementSlice = createSlice({
  name: "carrierManagementSlice",
  initialState,
  reducers: {
    requestCarriers: (state) => {
      state.isFetching = true;
    },
    receiveCarriersSuccess: (state, { payload }) => {
      state.carriers = payload.carriers;
      state.isFetching = false;
    },
    receiveCarriersFailure: (state) => {
      state.isFetching = false;
    },
  },
});

export const {
  requestCarriers,
  receiveCarriersSuccess,
  receiveCarriersFailure,
} = carrierManagementSlice.actions;

export const fetchCarriers = () => async (dispatch) => {
  let carriers;
  dispatch(requestCarriers());
  try {
    carriers = await getCarrierManagementList();
  } catch (e) {
    dispatch(receiveCarriersFailure());
    return;
  }
  dispatch(receiveCarriersSuccess({ carriers }));
};

export const searchCarriers = () => async (dispatch, getState) => {
  const state = getState();
  const filters = state.carrierManagementFilters;

  let carrierTier = filters.carrierTier == 1 ? null : filters.carrierTier;

  if (carrierTier !== null) carrierTier--;

  const params = {
    carrierTier: carrierTier,
    carrierName: filters.carrierName,
    contactName: filters.contactName,
    carrierOrganization: filters.carrierOrganization,
  };

  let carriers;
  dispatch(requestCarriers());
  try {
    carriers = await getCarrierManagementList(params);
  } catch (e) {
    dispatch(receiveCarriersFailure());
    return;
  }

  dispatch(receiveCarriersSuccess({ carriers }));
};

export const carrierManagementReducer = carrierManagementSlice.reducer;
